export enum LeadsSortColumn {
    INSERTED_AT = 'Date Inserted',
    STAGE = 'Stage',
}
